import fetch from "auth/FetchInterceptor";

const CustomerService = {};

CustomerService.getCustomers = function (page = 1, pagelimit = 20, filters = {}) {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("pagelimit", pagelimit);
  if (filters.search != null && String(filters.search).trim() !== "") {
    params.append("search", String(filters.search).trim());
  }
  return fetch({
    url: `/customers/?${params.toString()}`,
    method: "get",
  });
};

// Export the store's customers to an Excel file. Honours the search filter.
CustomerService.exportCustomers = function (filters = {}) {
  const params = new URLSearchParams();
  if (filters.search != null && String(filters.search).trim() !== "") {
    params.append("search", String(filters.search).trim());
  }
  const qs = params.toString();
  return fetch({
    url: `/customers/bulk/export/${qs ? `?${qs}` : ""}`,
    method: "get",
    responseType: "blob",
  });
};

export default CustomerService;
